(() => {
    const header = document.getElementById('header');
    if (header === null) {
        return;
    }

    const className = 'headers-scroll-0';
    let rememberHeaderScroll0 = true;

    const invalidate = function () {
        const currentWindowY = window.scrollY;
        if (! rememberHeaderScroll0) {
            if (currentWindowY === 0) {
                document.body.classList.add(className);
                rememberHeaderScroll0 = true;
            }
            return;
        }

        const headerBottom = header.offsetTop + header.offsetHeight;
        if (currentWindowY >= headerBottom && rememberHeaderScroll0) {
            document.body.classList.remove(className);
            rememberHeaderScroll0 = false;
        }
    };

    if (window.scrollY > 0) {
        document.body.classList.remove(className);
        rememberHeaderScroll0 = false;
    }

    document.addEventListener('scroll', () => {
        invalidate();
    }, { passive: true });
})()
